<script setup lang="ts">
import { UIIcon } from '@groover-dev/groover-ui'
import { storeToRefs } from 'pinia'

import { useDraftStore } from '~/stores/draft'

type Props = {
  typographicComponent?:
    | 'Sm400Black'
    | 'Sm400Gray'
    | 'Sm400Pink'
    | 'Sm600Error'
    | 'Xs600Error'
  iconClass: string
  text: string
  isTwoLines?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isTwoLines: false,
  typographicComponent: 'Sm400Black',
})

const { id: DRAFT_ID } = storeToRefs(useDraftStore())

const showCriteriaSocialProof = computed<boolean>(() => DRAFT_ID.value !== 0)
const componentClasses = computed(() => {
  switch (props.typographicComponent) {
    case 'Sm400Gray':
      return 'tw-text-sm tw-text-discrete2' //markRaw(Sm400Gray)
    case 'Sm400Pink':
      return 'tw-text-sm tw-text-pink-500' //markRaw(Sm400Pink)
    case 'Sm600Error':
      return 'tw-text-sm tw-font-bold tw-text-error' // markRaw(Sm600Error)
    case 'Xs600Error':
      return 'tw-text-xs tw-font-bold tw-text-error' //markRaw(Xs600Error)
    case 'Sm400Black':
    default:
      return 'tw-text-sm' //markRaw(Sm400Black)
  }
})

const iconColorClass = computed(() => {
  switch (props.typographicComponent) {
    case 'Sm400Pink':
      return 'tw-text-pink-500'
    case 'Sm600Error':
    case 'Xs600Error':
      return 'tw-flex tw-items-center tw-justify-center tw-text-sm tw-text-error'
    default:
      return ''
  }
})
</script>

<template>
  <div class="tw-flex tw-items-center">
    <UIIcon
      :name="iconClass"
      class="tw-mr-sm tw-h-lg tw-w-lg tw-text-center tw-text-base tw-text-discrete2"
      size="sm"
      :class="iconColorClass"
    />
    <span
      :class="[
        componentClasses,
        showCriteriaSocialProof && isTwoLines
          ? 'tw-line-clamp-2'
          : 'tw-ellipsis',
      ]"
      :title="text"
    >
      {{ text }}
    </span>
  </div>
</template>
